var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_108244",
    "data-name": "Group 108244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19787",
    "data-name": "Rectangle 19787",
    transform: "translate(0 0)",
    fill: "rgba(92,93,103,0)",
    stroke: "#4b8aeb",
    strokeWidth: 2,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 37,
    height: 37,
    rx: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-search",
    "data-name": "Icon feather-search",
    transform: "translate(13.473 13.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157059",
    "data-name": "Path 157059",
    d: "M15.476,9.988A5.488,5.488,0,1,1,9.988,4.5,5.488,5.488,0,0,1,15.476,9.988Z",
    transform: "translate(-4.5 -4.5)",
    fill: "none",
    stroke: "#4b8aeb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157060",
    "data-name": "Path 157060",
    d: "M27.959,27.959l-2.984-2.984",
    transform: "translate(-15.611 -15.611)",
    fill: "none",
    stroke: "#4b8aeb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBox);
export default __webpack_public_path__ + "static/media/search-box.44e7da398d568b4b6bea5d4fe81bd2b0.svg";
export { ForwardRef as ReactComponent };